import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { ID_TO_OPTIONS_NAMES_AND_COLORS } from "components/pages/whats-new/consts";
import { StyledHighlightCard } from "./highlight-card-component.scss";
import classnames from "classnames";
const HighlightCard = ({ imageUrl, title, description, releaseType, articleLink, isDesktop })=>{
    var _ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType;
    const BUTTON_TEXT = "Learn more";
    const releaseData = (_ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType = ID_TO_OPTIONS_NAMES_AND_COLORS.releaseType) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType === void 0 ? void 0 : _ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType.data[releaseType];
    return /*#__PURE__*/ _jsxs(StyledHighlightCard, {
        className: classnames("highlight-card", {
            "is-desktop": isDesktop
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "highlight-image",
                children: /*#__PURE__*/ _jsx("img", {
                    src: imageUrl,
                    alt: title
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card-content",
                children: [
                    releaseType && /*#__PURE__*/ _jsx("div", {
                        className: "release-type-wrapper",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "release-type",
                            children: releaseData === null || releaseData === void 0 ? void 0 : releaseData.name
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "highlight-title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "highlight-description",
                        children: description
                    }),
                    articleLink && /*#__PURE__*/ _jsx("div", {
                        className: "button-container",
                        children: /*#__PURE__*/ _jsx(SecondaryButton, {
                            buttonText: BUTTON_TEXT,
                            withoutUnderline: true,
                            url: articleLink,
                            isOpenLinkInNewTab: true
                        })
                    }),
                    !articleLink && /*#__PURE__*/ _jsx("div", {
                        className: "button-place-holder"
                    })
                ]
            })
        ]
    });
};
export default HighlightCard;
